export const GET_USER_DATA = "GET_USER_DATA";
export const GET_USER_DATA123 = "GET_USER_DATA123";
export const SIGN_UP_USER = "SIGN_UP_USER";
export const LOGIN_MODAL = "LOGIN_MODAL";
export const SET_MEETING_IS_STARTED = "SET_MEETING_IS_STARTED";
export const SET_LIVE_MEETING = "SET_LIVE_MEETING";
export const SET_MINIMIZE = "SET_MINIMIZE";
export const SET_MAXIMIZE = "SET_MAXIMIZE";